import { apiCall, createQueryString } from "../imports";

const PREFIX = "notices/admin/bids";

export default {
  // لیست همه پیشنهادها
  get(filters = {}) {
    return apiCall("get", `${PREFIX}${createQueryString(filters)}`);
  },

  // جزئیات یک پیشنهاد
  show(id) {
    return apiCall("get", `${PREFIX}/${id}`);
  },

  // ایجاد پیشنهاد دستی توسط ادمین در صورت نیاز
  create(data) {
    return apiCall("post", `${PREFIX}`, data);
  },

  // ویرایش پیشنهاد
  update(id, data) {
    return apiCall("put", `${PREFIX}/${id}`, data);
  },

  // حذف پیشنهاد
  delete(id) {
    return apiCall("delete", `${PREFIX}/${id}`);
  },

  // پیشنهادهای یک مناقصه/مزایده
  getByNotice(noticeId, filters = {}) {
    return apiCall("get", `notices/admin/notices/${noticeId}/bids${createQueryString(filters)}`);
  },

  // پیشنهادهای آیتم‌های پایان‌یافته
  getClosed(filters = {}) {
    return apiCall("get", `notices/admin/closed-bids${createQueryString(filters)}`);
  },
};